import PendingOrders from "../symbols/pendingOrders";
import { HttpRequestPost } from "../../service";
import { roleName } from "../../utils/roles";
export interface IOrderFilter {
  Shop?: string[];
  Status: string[];
  DateRange?: string[];
}
type GetOrdersRequestModel = {
  Filter: IOrderFilter;
  OrderBy: string;
  Query: string;
  Page: number;
  Size: number;
};
const pendingOrdersAction = () => ({
  type: PendingOrders.PENDING_ORDERS,
});
const pendingOrdersSuccessAction = (data: any) => ({
  type: PendingOrders.PENDING_ORDERS_SUCCESS,
  payload: data,
});
const pendingOrdersFailureAction = (data: any) => ({
  type: PendingOrders.PENDING_ORDERS_FAILURE,
  payload: data,
});
const clearPendingOrdersAction = () => ({
  type: PendingOrders.CLEAR_PENDING_ORDERS,
});
export function getPendingOrders(
  data?: GetOrdersRequestModel,
  callback?: (resp?: any) => void,
  role?: string
) {
  let url = `/${
    role ? role.toLowerCase() : roleName().toLowerCase()
  }/deliveries/Pending`;

  return (dispatch: any) => {
    dispatch(pendingOrdersAction());
    HttpRequestPost(
      url,
      dispatch,
      pendingOrdersSuccessAction,
      pendingOrdersFailureAction,
      true,
      data || {
        Query: "",
        Filter: { Status: [] },
        OrderBy: "desc",
      },
      callback
    );
  };
}

export function clearPendingOrders() {
  return (dispatch: any) => {
    dispatch(clearPendingOrdersAction());
  };
}
